import { Input } from "antd";
import React from "react";
import styled from "styled-components";
import { CloseEye, OpenEye } from "@assets";

const PasswordInput = styled(Input.Password)`
  background-color: #FFFFFF;

  height: 56px;
  &::placeholder {
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #0000004D;
  }

   input {
    text-align: center !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    background-color: #FFFFFF;
    color: #000;
  }
  
  &&& {
    border-radius: 26px;
    text-align: center !important;
    padding-left: 17px;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

const InputPassword = ({ placeholder, ...props }) => {
  
  const handleKeyDown = (event) => {
    const key = event.key;
    const isAllowedKey = /^[0-9\b]+$/.test(key);
    if (!isAllowedKey && key !== "Backspace") {
      event.preventDefault();
    }
  };

  return (

    <PasswordInput 
      size="large"
      placeholder={placeholder}
      onKeyDown={handleKeyDown}
      iconRender={(visible) => (visible ? <OpenEye /> : <CloseEye />)}
      {...props}
    />
  );
};

export default InputPassword;
